export default "__VITE_ASSET__lOvjyiqm__";